var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelchair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.335,
    height: 36.282,
    viewBox: "0 0 25.335 36.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M229.295,495.893a3.243,3.243,0,0,1-2.413-1.005,3.4,3.4,0,0,1,0-4.781,3.243,3.243,0,0,1,2.413-1.005,3.192,3.192,0,0,1,2.368,1.005,3.4,3.4,0,0,1,0,4.781,3.192,3.192,0,0,1-2.368,1.005m9.473,29.356V515.91h-9.2a3.585,3.585,0,0,1-3.575-3.575V501.612a3.28,3.28,0,0,1,3.306-3.307,3.645,3.645,0,0,1,1.653.357,6.065,6.065,0,0,1,1.7,1.519,21.565,21.565,0,0,0,4.178,3.552,9.569,9.569,0,0,0,4.982,1.586v2.815a11.422,11.422,0,0,1-4.647-1.072,20.4,20.4,0,0,1-4.647-2.9V512.2h5.719a3.432,3.432,0,0,1,3.441,3.441v9.607Zm-13.449.134a8.518,8.518,0,0,1-6.3-2.569,8.633,8.633,0,0,1-2.547-6.323,8.545,8.545,0,0,1,2.256-5.7,8.782,8.782,0,0,1,5.92-3.016v2.994a5.392,5.392,0,0,0-3.8,1.944,5.852,5.852,0,0,0,4.513,9.718,5.862,5.862,0,0,0,3.753-1.407,5.131,5.131,0,0,0,1.921-3.776h2.994a8.34,8.34,0,0,1-2.971,5.876,8.71,8.71,0,0,1-5.742,2.256",
    transform: "translate(-216.471 -489.101)",
    fill: "#939598"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchair);
export default __webpack_public_path__ + "static/media/wheelchair.9a777b57656beb73dbac9a6e70d9b702.svg";
export { ForwardRef as ReactComponent };